const m = window.require("rsvp");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;